/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const MapMarker: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.99414 0C10.7141 0 12.9241 2.17 12.9841 4.88C12.9941 4.91 12.9841 5.2 12.9741 5.31C12.9341 5.76 12.8041 6.31 12.6141 6.93C12.6141 6.94 12.6041 6.95 12.6041 6.95C11.6841 9.93 9.35414 14.38 8.40414 15.78C8.20414 16.07 7.77414 16.07 7.58414 15.78C6.61414 14.36 4.18414 9.76 3.31414 6.76C3.15414 6.22 3.05414 5.73 3.01414 5.32C3.00414 5.21 2.99414 4.91 3.00414 4.88C3.06414 2.17 5.27414 0 7.99414 0ZM5.49414 5C5.49414 6.38 6.61414 7.5 7.99414 7.5C9.37414 7.5 10.4941 6.38 10.4941 5C10.4941 3.62 9.37414 2.5 7.99414 2.5C6.61414 2.5 5.49414 3.62 5.49414 5Z'
			/>
		</Svg>
	);
};

export { MapMarker };
